import { render } from "./resultModal.vue?vue&type=template&id=1e62fc30&scoped=true"
import script from "./resultModal.vue?vue&type=script&lang=js"
export * from "./resultModal.vue?vue&type=script&lang=js"

import "./resultModal.vue?vue&type=style&index=0&id=1e62fc30&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e62fc30"]])

export default __exports__